import { Component, OnInit } from '@angular/core';
import { SharedMethods } from '../services/sharedMethods-service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.sass']
})
export class FooterComponent implements OnInit {

  description = '';
  footerlink: any[] = [];
  newsletterText = '';
  adresse = '';
  contact = '';
  email = '';
  network: any[] = [];

  constructor(private sharedMethods: SharedMethods,) { }

  ngOnInit() {

    if(this.sharedMethods.cacheSettings === undefined) {

      this.sharedMethods.getSettings().subscribe(setting => {
        this.sharedMethods.cacheSettings = setting;
        this.description = this.sharedMethods.cacheSettings.description;
        this.footerlink = this.sharedMethods.cacheSettings.footerlink;
        this.newsletterText = this.sharedMethods.cacheSettings.newsletterText;
        this.adresse = this.sharedMethods.cacheSettings.adresse;
        this.contact = this.sharedMethods.cacheSettings.contact;
        this.email = this.sharedMethods.cacheSettings.email;
        this.network = this.sharedMethods.cacheSettings.network;
      });

    } else {

      this.description = this.sharedMethods.cacheSettings.description;
      this.footerlink = this.sharedMethods.cacheSettings.footerlink;
      this.newsletterText = this.sharedMethods.cacheSettings.newsletterText;
      this.adresse = this.sharedMethods.cacheSettings.adresse;
      this.contact = this.sharedMethods.cacheSettings.contact;
      this.email = this.sharedMethods.cacheSettings.email;
      this.network = this.sharedMethods.cacheSettings.network;
    }

  }

}
